import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.less'

const AttrString = ({ product }) => {
    const getGroupName = (attr, attrs = []) => {
        if (!attr.groupKey) {
            return ''
        }

        // 优先从 productExtraAttrSubKeyValues 中查找
        if (product.productExtraAttrSubKeyValues?.length > 0) {
            const subKeyObj = product.productExtraAttrSubKeyValues.find(
                item => item.key === attr.productExtraAttrSubKey
            )
            if (subKeyObj?.groupName) {
                return `${subKeyObj.groupName} - `
            }
        }

        // 从 attrs 中查找
        const attrObj = attrs.find(item => item.attrKey === attr.productExtraAttrKey)
        if (attrObj?.attrName) {
            return `${attrObj.attrName} - `
        }

        return ''
    }

    const renderSpecItem = () => {
        if (!product.specItem) {
            return null
        }

        return (
            <div className='cart-item-specs'>
                <small>{product.specItem.productExtraSpecName} * 1</small>
            </div>
        )
    }

    const renderAttrArr = () => {
        if (!product.attrArr?.length) {
            return null
        }

        const attrStrings = product.attrArr.map(item => {
            const groupName = getGroupName(item, product.attrs)
            const quantity = item.quantity || 1
            return `${groupName}${item.productExtraAttrSubName} * ${quantity}`
        })

        return (
            <div className='text-gray'>
                <small>{attrStrings.join(', ')}</small>
            </div>
        )
    }

    return (
        <div className={styles.attrString}>
            {renderSpecItem()}
            {renderAttrArr()}
        </div>
    )
}

AttrString.propTypes = {
    product: PropTypes.shape({
        specItem: PropTypes.shape({
            productExtraSpecName: PropTypes.string
        }),
        attrArr: PropTypes.arrayOf(PropTypes.shape({
            groupKey: PropTypes.string,
            productExtraAttrSubKey: PropTypes.string,
            productExtraAttrKey: PropTypes.string,
            productExtraAttrSubName: PropTypes.string,
            quantity: PropTypes.number
        })),
        attrs: PropTypes.arrayOf(PropTypes.shape({
            attrKey: PropTypes.string,
            attrName: PropTypes.string
        })),
        productExtraAttrSubKeyValues: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            groupName: PropTypes.string
        }))
    }).isRequired
}

export default AttrString
